import { __ } from '@wordpress/i18n';
import { PanelBody, RangeControl, PanelRow, SelectControl, __experimentalNumberControl as NumberControl, TextControl, ToggleControl } from "@wordpress/components";
import { Label } from '../../../../../../bpl-tools/Components';
import { filterSelected, strToIntArr } from '../../../../utils/functions';
import { postsOrders, postsOrdersBy } from '../../../../utils/options';
import SelectTokenField from '../../../Panel/SelectTokenField';
import { BControlPro } from '../../../../../../bpl-tools/ProControls';

const PostQuery = ({ updateObject, attributes, getTaxonomy, premiumProps }) => {

    const { postsQuery, sourceType } = attributes;
    const { selectedTags, selectedCategories, per_page, orderby, order, offset, include, exclude, isExcludeCurrent, isExcerptFromContent, excerptLength } = postsQuery;

    return <PanelBody className='bPlPanelBody' title={__('Posts Query', 'slider')} initialOpen={false}>
        {
            sourceType === 'posts' && <>
                {getTaxonomy('category')?.length ? <>
                    <Label className='mt10 mb0'>{__('Select Categories:', 'slider')}</Label>
                    <SelectTokenField
                        value={filterSelected(getTaxonomy('category'), selectedCategories).map(cat => cat.toString())}
                        onChange={val => updateObject("postsQuery", "selectedCategories", val.map(cat => parseInt(cat)))}
                        options={getTaxonomy('category').map(cat => ({ label: cat.name, value: cat.id.toString() }))}
                    /></> : null
                }

                <Label className="mt10 mb0">{__('Select Tags:', 'slider')}</Label>
                <SelectTokenField
                    className='mt20'
                    label={__('Select Tags:', 'slider')}
                    value={filterSelected(getTaxonomy('post_tag'), selectedTags)?.map(tag => tag.toString())}
                    onChange={val => updateObject("postsQuery", "selectedTags", val.map(tag => parseInt(tag)))}
                    options={getTaxonomy('post_tag')?.map(tag => ({ label: tag.name, value: tag.id.toString() }))} />
            </>
        }

        <Label>{__('Post Per Page:', 'slider')}</Label>
        <BControlPro value={per_page} onChange={val => updateObject("postsQuery", "per_page", val)} min={-1} max={36} step={1} Component={RangeControl} {...premiumProps} />
        <small>{__('To show all posts set -1', 'slider')}</small>

        <PanelRow className='mt20'>
            <Label className=''>{__('Post Order By:', 'slider')}</Label>
            <BControlPro value={orderby} onChange={val => updateObject("postsQuery", "orderby", val)} options={postsOrdersBy} Component={SelectControl} {...premiumProps} />
        </PanelRow>

        <PanelRow className='mt20'>
            <Label className=''>{__('Post Order:', 'slider')}</Label>
            <BControlPro value={order} onChange={val => updateObject("postsQuery", "order", val)} options={postsOrders} Component={SelectControl} {...premiumProps} />
        </PanelRow>

        <BControlPro className='mt20' label={__('Post Offset:', 'slider')} labelPosition='left' value={offset} onChange={val => updateObject("postsQuery", "offset", parseInt(val))} min={0} Component={NumberControl} {...premiumProps} />
        <small>{__('`Post Offset` will not work if `Post Per Page` is -1', 'slider')}</small>

        <BControlPro className='mt20' label={__('Include Posts:', 'slider')} value={include?.join(',')} onChange={val => updateObject("postsQuery", "include", strToIntArr(val))} Component={TextControl} {...premiumProps} />
        <small>{__('Enter the posts id by coma separated Ex: `23,45,16`', 'slider')}</small>

        <BControlPro className='mt20' label={__('Exclude Posts:', 'slider')} value={exclude?.join(',')} onChange={val => updateObject("postsQuery", "exclude", strToIntArr(val))} Component={TextControl} {...premiumProps} />
        <small>{__('Enter the posts id by coma separated Ex: `23,45,16`', 'slider')}</small>

        <BControlPro className='mt20' label={__('Exclude Current Post', 'slider')} checked={isExcludeCurrent} onChange={val => updateObject("postsQuery", "isExcludeCurrent", val)} Component={ToggleControl} {...premiumProps} />

        <ToggleControl className='mt15' label={__('Show Excerpt from Content', 'slider')} checked={isExcerptFromContent} onChange={val => updateObject("postsQuery", "isExcerptFromContent", val)} />

        {/* <Label className='mt15'>{__('Excerpt Length:', 'slider')}</Label> */}
        <Label className='mt15'>{__('Content Length:', 'slider')}</Label>
        <RangeControl value={excerptLength} onChange={val => updateObject("postsQuery", "excerptLength", val)} min={-1} max={120} step={1} />
        {/* <small>{__(`Set -1 to show all the ${isExcerptFromContent ? 'content' : 'excerpt'}`, 'slider')}</small> */}
    </PanelBody >
}
export default PostQuery;